// extracted by mini-css-extract-plugin
var _1 = "BlockMoveToAnotherSectionModal_content__64743";
var _2 = "BlockMoveToAnotherSectionModal_search__29869";
export { _1 as "content", _2 as "search" }
